var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCustomMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.073 3.374a.998.998 0 00.806-.465L4.449 2l.04 1.073c.013.33.187.63.466.805l.909.571-1.073.041a.992.992 0 00-.805.465l-.572.91-.04-1.074a.994.994 0 00-.465-.806l-.91-.57 1.074-.04zm9.677 8.767l6.738-3.753.01 7.135-.602-.36-.513.858.611.365-6.25 3.481.006-7.726zm-.745-1.302l-6.42-3.554 6.397-3.563 6.42 3.553-6.397 3.564zm-.761 9.018l-6.238-3.452.61-.367-.516-.856-.6.36-.01-7.148 6.759 3.74-.005 7.723zm9.744-12.279a1 1 0 00-.517-.872l-8.004-4.43a1 1 0 00-.972 0l-7.98 4.446A1 1 0 003 7.595v8.826a1 1 0 00.516.874l8.005 4.43c.302.167.67.167.973-.002l7.992-4.451c.318-.177.514-.512.514-.875l-.012-8.819zm-12.992 7.03l-.517-.856-1.359.817.517.856 1.359-.818zm1.862-2.286l.517.855-1.36.818-.516-.857 1.36-.816zM16 14.597l1.36.814.515-.858-1.36-.813-.515.857zm-1.021-.61l-1.362-.814.514-.857 1.362.813-.514.858zM19.04 20.1c.281.177.457.481.469.813l.04 1.068.568-.905c.177-.28.481-.457.813-.469l1.068-.04-.905-.569a1.003 1.003 0 01-.469-.813l-.04-1.067-.568.904a1.006 1.006 0 01-.813.47l-1.069.04.906.568z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomMaterial);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconCustomMaterial.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };